<template>
  <div class="d-flex flex-column justify-center align-center">
    <p class="text-h5 font-weight-bold ma-0 my-3">
      {{ userMegaLeague?.user?.nickname }}
    </p>
    <score
      :score="userMegaLeague.totalScore"
      :max-score="userMegaLeague.maxScore()"
      size="xlg"
    />
  </div>
</template>
<script>
import Score from "@/components/Card/Score.vue";
import UserMegaLeague from "@/models/MegaLeague/userMegaLeague";

export default {
  name: "UserScore",
  components: {
    Score,
  },
  props: {
    userMegaLeague: {
      type: UserMegaLeague,
      required: true,
    },
  },
};
</script>
